var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInputPincode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 0H3.75C2.75544 0 1.80161 0.395088 1.09835 1.09835C0.395088 1.80161 0 2.75544 0 3.75V21.25C0 22.2446 0.395088 23.1984 1.09835 23.9017C1.80161 24.6049 2.75544 25 3.75 25H31.25C32.2446 25 33.1984 24.6049 33.9016 23.9017C34.6049 23.1984 35 22.2446 35 21.25V3.75C35 2.75544 34.6049 1.80161 33.9016 1.09835C33.1984 0.395088 32.2446 0 31.25 0ZM32.5 21.25C32.5 21.5815 32.3683 21.8995 32.1339 22.1339C31.8995 22.3683 31.5815 22.5 31.25 22.5H3.75C3.41848 22.5 3.10054 22.3683 2.86612 22.1339C2.6317 21.8995 2.5 21.5815 2.5 21.25V6.4L15.825 13.0625C16.3465 13.3176 16.9194 13.4502 17.5 13.4502C18.0806 13.4502 18.6535 13.3176 19.175 13.0625L32.5 6.4V21.25ZM32.5 3.75C32.3049 3.74326 32.1114 3.78627 31.9375 3.875L18.0625 10.8125C17.888 10.9004 17.6954 10.9462 17.5 10.9462C17.3046 10.9462 17.112 10.9004 16.9375 10.8125L3.0625 3.8875C2.8898 3.79444 2.69616 3.7471 2.5 3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H31.25C31.5815 2.5 31.8995 2.6317 32.1339 2.86612C32.3683 3.10054 32.5 3.41848 32.5 3.75Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputPincode);
export default __webpack_public_path__ + "static/media/icon_input_pincode.d21c6ad98aee198470a0a04183dff1c9.svg";
export { ForwardRef as ReactComponent };